import { useMutation } from "react-query";
import { Scope3 } from "../../api";
import { useAuth } from "../../context";

// CATEGORY 1
export function useUpdatePurchasedGoodsAndServices(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, id, data }) =>
    callApi(Scope3.updatePurchasedGoodsAndServices, { questionnaireId, data }), config);
}

// CATEGORY 4
export function useUpdateUpstreamTransportationAndDistributionCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateUpstreamTransportationAndDistribution, { questionnaireId, data }), config);
}

// CATEGORY 5
export function useUpdateWasteGeneratedInOperationsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateWasteGeneratedInOperations, { questionnaireId, data }), config);
}

// CATEGORY 6
export function useUpdateBusinessTravelCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateBusinessTravel, { questionnaireId, data }), config);
}

// CATEGORY 7
export function useUpdateEmployeeCommutingCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateEmployeeCommuting, { questionnaireId, data }), config);
}

// CATEGORY 8
export function useCreateUpstreamLeasedAssetsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.createUpstreamLeasedAssets, { questionnaireId, data }), config);
}
export function useUpdateUpstreamLeasedAssetsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Scope3.updateUpstreamLeasedAsssets, { questionnaireId, id, data }), config);
}

// CATEGORY 9
export function useUpdateDownstreamTransportationAndDistributionCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateDownstreamTransportationDistribution, { questionnaireId, data }), config);
}

// CATEGORY 10
export function useCreateProcessingOfSoldProductsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.createProcessingOfSoldProducts, { questionnaireId, data }), config);
}
export function useUpdateProcessingOfSoldProductsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Scope3.updateProcessingOfSoldProducts, { questionnaireId, id, data }), config);
}

// CATEGORY 12
export function useUpdateTreatmentOfSoldProductsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.updateTreatmentOfSoldProducts, { questionnaireId, data }), config);
}

// CATEGORY 13
export function useCreateDownstreamLeasedAssetsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.createDownstreamLeasedAssets, { questionnaireId, data }), config);
}
export function useUpdateDownstreamLeasedAssetsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Scope3.updateDownstreamLeasedAssets, { questionnaireId, id, data }), config);
}

// CATEGORY 14
export function useCreateFranchisesCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.createFranchises, { questionnaireId, data }), config);
}
export function useUpdateFranchisesCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Scope3.updateFranchises, { questionnaireId, id, data }), config);
}

// CATEGORY 15
export function useCreateInvestmentsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(Scope3.createInvestments, { questionnaireId, data }), config);
}
export function useUpdateInvestmentsCategory(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(Scope3.updateInvestments, { questionnaireId, id, data }), config);
}